export const REDUCER_NAME = 'TabSlider'

export const actions = {
  INITIALIZE: 'TabSlider/INITIALIZE',
  CHOOSE_TAB: 'TabSlider/CHOOSE_TAB',
}

export const EVENT_KEYS = {
  TAB_KEY: '9',
  LEFT_ARROW_KEY: '37',
  RIGHT_ARROW_KEY: '39',
}
